import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {
    IEcommercePerformanceReportNetSalesLastYearEntityState
} from "../reducers/ecommerce-performance-net-sales-last-year.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePerformanceReportNetSalesLastYearState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePerformanceReportNetSalesLastYear.entities[websiteId]);

export const getEcommercePerformanceReportNetSalesLastYear = (websiteId: number) => createSelector(getEcommercePerformanceReportNetSalesLastYearState(websiteId),
  (state: IEcommercePerformanceReportNetSalesLastYearEntityState) => {
      return state.netSalesDataLastYear;
  }
);

export const getEcommercePerformanceReportNetSalesLastYearLoading = (websiteId: number) => createSelector(getEcommercePerformanceReportNetSalesLastYearState(websiteId),
  (state: IEcommercePerformanceReportNetSalesLastYearEntityState) => state && state.loading
);

export const getEcommercePerformanceReportNetSalesLastYearLoaded = (websiteId: number) => createSelector(getEcommercePerformanceReportNetSalesLastYearState(websiteId),
  (state: IEcommercePerformanceReportNetSalesLastYearEntityState) => state && state.loaded
);
